import React from 'react';
import { colors, mobileStyles } from '../../styles/theme';

/**
 * ContractorNerd Logo
 */
export const Logo = () => (
  <svg width="180" height="35" viewBox="0 0 238 46" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M223.637 25.28C223.637 23.904 223.893 22.696 224.405 21.656C224.933 20.616 225.645 19.816 226.541 19.256C227.437 18.696 228.437 18.416 229.541 18.416C230.421 18.416 231.221 18.6 231.941 18.968C232.677 19.336 233.253 19.832 233.669 20.456V14.24H237.773V32H233.669V30.08C233.285 30.72 232.733 31.232 232.013 31.616C231.309 32 230.485 32.192 229.541 32.192C228.437 32.192 227.437 31.912 226.541 31.352C225.645 30.776 224.933 29.968 224.405 28.928C223.893 27.872 223.637 26.656 223.637 25.28ZM233.669 25.304C233.669 24.28 233.381 23.472 232.805 22.88C232.245 22.288 231.557 21.992 230.741 21.992C229.925 21.992 229.229 22.288 228.653 22.88C228.093 23.456 227.813 24.256 227.813 25.28C227.813 26.304 228.093 27.12 228.653 27.728C229.229 28.32 229.925 28.616 230.741 28.616C231.557 28.616 232.245 28.32 232.805 27.728C233.381 27.136 233.669 26.328 233.669 25.304Z" fill="#181815"/>
    <path d="M218.291 20.84C218.771 20.104 219.371 19.528 220.091 19.112C220.811 18.68 221.612 18.464 222.492 18.464V22.808H221.363C220.339 22.808 219.571 23.032 219.059 23.48C218.547 23.912 218.291 24.68 218.291 25.784V32H214.188V18.608H218.291V20.84Z" fill="#181815"/>
    <path d="M212.022 25.088C212.022 25.472 211.998 25.872 211.95 26.288H202.662C202.726 27.12 202.99 27.76 203.454 28.208C203.934 28.64 204.518 28.856 205.206 28.856C206.23 28.856 206.942 28.424 207.342 27.56H211.71C211.486 28.44 211.078 29.232 210.486 29.936C209.91 30.64 209.182 31.192 208.302 31.592C207.422 31.992 206.438 32.192 205.35 32.192C204.038 32.192 202.87 31.912 201.846 31.352C200.822 30.792 200.022 29.992 199.446 28.952C198.87 27.912 198.582 26.696 198.582 25.304C198.582 23.912 198.862 22.696 199.422 21.656C199.998 20.616 200.798 19.816 201.822 19.256C202.846 18.696 204.022 18.416 205.35 18.416C206.646 18.416 207.798 18.688 208.806 19.232C209.814 19.776 210.598 20.552 211.158 21.56C211.734 22.568 212.022 23.744 212.022 25.088ZM207.822 24.008C207.822 23.304 207.582 22.744 207.102 22.328C206.622 21.912 206.022 21.704 205.302 21.704C204.614 21.704 204.03 21.904 203.55 22.304C203.086 22.704 202.798 23.272 202.686 24.008H207.822Z" fill="#181815"/>
    <path d="M196.424 32H192.32L185.456 21.608V32H181.352V15.152H185.456L192.32 25.592V15.152H196.424V32Z" fill="#181815"/>
    <path d="M175.19 20.84C175.67 20.104 176.27 19.528 176.99 19.112C177.71 18.68 178.51 18.464 179.39 18.464V22.808H178.262C177.238 22.808 176.47 23.032 175.958 23.48C175.446 23.912 175.19 24.68 175.19 25.784V32H171.086V18.608H175.19V20.84Z" fill="#181815"/>
    <path d="M161.9 32.192C160.588 32.192 159.404 31.912 158.348 31.352C157.308 30.792 156.484 29.992 155.876 28.952C155.284 27.912 154.988 26.696 154.988 25.304C154.988 23.928 155.292 22.72 155.9 21.68C156.508 20.624 157.34 19.816 158.396 19.256C159.452 18.696 160.636 18.416 161.948 18.416C163.26 18.416 164.444 18.696 165.5 19.256C166.556 19.816 167.388 20.624 167.996 21.68C168.604 22.72 168.908 23.928 168.908 25.304C168.908 26.68 168.596 27.896 167.972 28.952C167.364 29.992 166.524 30.792 165.452 31.352C164.396 31.912 163.212 32.192 161.9 32.192ZM161.9 28.64C162.684 28.64 163.348 28.352 163.892 27.776C164.452 27.2 164.732 26.376 164.732 25.304C164.732 24.232 164.46 23.408 163.916 22.832C163.388 22.256 162.732 21.968 161.948 21.968C161.148 21.968 160.484 22.256 159.956 22.832C159.428 23.392 159.164 24.216 159.164 25.304C159.164 26.376 159.42 27.2 159.932 27.776C160.46 28.352 161.116 28.64 161.9 28.64Z" fill="#181815"/>
    <path d="M153.518 28.52V32H151.43C149.942 32 148.782 31.64 147.95 30.92C147.118 30.184 146.702 28.992 146.702 27.344V22.016H145.07V18.608H146.702V15.344H150.806V18.608H153.494V22.016H150.806V27.392C150.806 27.792 150.902 28.08 151.094 28.256C151.286 28.432 151.606 28.52 152.054 28.52H153.518Z" fill="#181815"/>
    <path d="M130.707 25.304C130.707 23.912 130.987 22.696 131.547 21.656C132.123 20.616 132.915 19.816 133.923 19.256C134.947 18.696 136.115 18.416 137.427 18.416C139.107 18.416 140.507 18.856 141.627 19.736C142.763 20.616 143.507 21.856 143.859 23.456H139.491C139.123 22.432 138.411 21.92 137.355 21.92C136.603 21.92 136.003 22.216 135.555 22.808C135.107 23.384 134.883 24.216 134.883 25.304C134.883 26.392 135.107 27.232 135.555 27.824C136.003 28.4 136.603 28.688 137.355 28.688C138.411 28.688 139.123 28.176 139.491 27.152H143.859C143.507 28.72 142.763 29.952 141.627 30.848C140.491 31.744 139.091 32.192 137.427 32.192C136.115 32.192 134.947 31.912 133.923 31.352C132.915 30.792 132.123 29.992 131.547 28.952C130.987 27.912 130.707 26.696 130.707 25.304Z" fill="#181815"/>
    <path d="M114.418 25.28C114.418 23.904 114.674 22.696 115.186 21.656C115.714 20.616 116.426 19.816 117.322 19.256C118.218 18.696 119.218 18.416 120.322 18.416C121.266 18.416 122.09 18.608 122.794 18.992C123.514 19.376 124.066 19.88 124.45 20.504V18.608H128.554V32H124.45V30.104C124.05 30.728 123.49 31.232 122.77 31.616C122.066 32 121.242 32.192 120.298 32.192C119.21 32.192 118.218 31.912 117.322 31.352C116.426 30.776 115.714 29.968 115.186 28.928C114.674 27.872 114.418 26.656 114.418 25.28ZM124.45 25.304C124.45 24.28 124.162 23.472 123.586 22.88C123.026 22.288 122.338 21.992 121.522 21.992C120.706 21.992 120.01 22.288 119.434 22.88C118.874 23.456 118.594 24.256 118.594 25.28C118.594 26.304 118.874 27.12 119.434 27.728C120.01 28.32 120.706 28.616 121.522 28.616C122.338 28.616 123.026 28.32 123.586 27.728C124.162 27.136 124.45 26.328 124.45 25.304Z" fill="#181815"/>
    <path d="M109.073 20.84C109.553 20.104 110.153 19.528 110.873 19.112C111.593 18.68 112.393 18.464 113.273 18.464V22.808H112.145C111.121 22.808 110.353 23.032 109.841 23.48C109.329 23.912 109.073 24.68 109.073 25.784V32H104.969V18.608H109.073V20.84Z" fill="#181815"/>
    <path d="M102.682 28.52V32H100.594C99.1064 32 97.9464 31.64 97.1144 30.92C96.2824 30.184 95.8664 28.992 95.8664 27.344V22.016H94.2344V18.608H95.8664V15.344H99.9704V18.608H102.658V22.016H99.9704V27.392C99.9704 27.792 100.066 28.08 100.258 28.256C100.45 28.432 100.77 28.52 101.218 28.52H102.682Z" fill="#181815"/>
    <path d="M87.2069 18.464C88.7749 18.464 90.0229 18.976 90.9509 20C91.8949 21.008 92.3669 22.4 92.3669 24.176V32H88.2869V24.728C88.2869 23.832 88.0549 23.136 87.5909 22.64C87.1269 22.144 86.5029 21.896 85.7189 21.896C84.9349 21.896 84.3109 22.144 83.8469 22.64C83.3829 23.136 83.1509 23.832 83.1509 24.728V32H79.0469V18.608H83.1509V20.384C83.5669 19.792 84.1269 19.328 84.8309 18.992C85.5349 18.64 86.3269 18.464 87.2069 18.464Z" fill="#181815"/>
    <path d="M69.8612 32.192C68.5492 32.192 67.3652 31.912 66.3092 31.352C65.2692 30.792 64.4452 29.992 63.8372 28.952C63.2452 27.912 62.9492 26.696 62.9492 25.304C62.9492 23.928 63.2532 22.72 63.8612 21.68C64.4692 20.624 65.3012 19.816 66.3572 19.256C67.4132 18.696 68.5972 18.416 69.9092 18.416C71.2212 18.416 72.4052 18.696 73.4612 19.256C74.5172 19.816 75.3492 20.624 75.9572 21.68C76.5652 22.72 76.8692 23.928 76.8692 25.304C76.8692 26.68 76.5572 27.896 75.9332 28.952C75.3252 29.992 74.4852 30.792 73.4132 31.352C72.3572 31.912 71.1732 32.192 69.8612 32.192ZM69.8612 28.64C70.6452 28.64 71.3092 28.352 71.8532 27.776C72.4132 27.2 72.6932 26.376 72.6932 25.304C72.6932 24.232 72.4212 23.408 71.8772 22.832C71.3492 22.256 70.6932 21.968 69.9092 21.968C69.1092 21.968 68.4452 22.256 67.9172 22.832C67.3892 23.392 67.1252 24.216 67.1252 25.304C67.1252 26.376 67.3812 27.2 67.8932 27.776C68.4212 28.352 69.0772 28.64 69.8612 28.64Z" fill="#181815"/>
    <path d="M44.7881 23.552C44.7881 21.888 45.1481 20.408 45.8681 19.112C46.5881 17.8 47.5881 16.784 48.8681 16.064C50.1641 15.328 51.6281 14.96 53.2601 14.96C55.2601 14.96 56.9721 15.488 58.3961 16.544C59.8201 17.6 60.7721 19.04 61.2521 20.864H56.7401C56.4041 20.16 55.9241 19.624 55.3001 19.256C54.6921 18.888 53.9961 18.704 53.2121 18.704C51.9481 18.704 50.9241 19.144 50.1401 20.024C49.3561 20.904 48.9641 22.08 48.9641 23.552C48.9641 25.024 49.3561 26.2 50.1401 27.08C50.9241 27.96 51.9481 28.4 53.2121 28.4C53.9961 28.4 54.6921 28.216 55.3001 27.848C55.9241 27.48 56.4041 26.944 56.7401 26.24H61.2521C60.7721 28.064 59.8201 29.504 58.3961 30.56C56.9721 31.6 55.2601 32.12 53.2601 32.12C51.6281 32.12 50.1641 31.76 48.8681 31.04C47.5881 30.304 46.5881 29.288 45.8681 27.992C45.1481 26.696 44.7881 25.216 44.7881 23.552Z" fill="#181815"/>
    <path d="M26.5146 0C26.7623 0.000111194 26.9637 0.199797 26.9639 0.446289V8.10352C26.9638 8.34984 26.7626 8.54969 26.5146 8.5498H23.2988C23.1155 8.54964 22.95 8.43888 22.8818 8.26953C22.4626 7.22667 21.462 6.55191 20.332 6.55176H20.0205C19.635 6.55181 19.2598 6.63067 18.9072 6.78613C17.8618 7.24707 17.0681 8.13517 16.7295 9.2207L16.3672 10.3828C16.3683 10.3929 16.3708 10.4025 16.3711 10.4131L16.4062 11.4678L16.9502 17.9814L15.6875 18.0859L15.0859 10.875H12.5449L11.9766 17.6934L10.7139 17.5889L11.3164 10.3594C10.8536 9.43711 10.0306 8.76355 9.01855 8.49512C7.91611 8.20304 6.76354 8.43387 5.8584 9.12988C4.59433 10.1023 3.21943 11.3502 1.77344 12.8389C1.68681 12.9277 1.56947 12.9755 1.4502 12.9756C1.39073 12.9755 1.33115 12.9635 1.27441 12.9395C1.10281 12.8665 0.99459 12.6959 1.00195 12.5107C1.00697 12.3896 1.67558 0.462063 16.8965 0.461914C17.0155 0.462237 17.1314 0.503935 17.2178 0.585938L18.2617 1.5791C18.7778 2.07043 19.4554 2.34077 20.1699 2.34082C21.2661 2.34074 22.2588 1.69585 22.6982 0.697266L22.8877 0.267578C22.9594 0.105035 23.1207 0.000160399 23.2988 0H26.5146Z" fill="#181815"/>
    <rect y="17" width="27" height="2" fill="#F3F3F0"/>
    <path d="M26.4424 41.6169L24.8154 42.6951C21.5503 44.8579 17.7355 46.0007 13.7861 46.0007C9.31953 46.0007 4.94491 44.4964 1.46973 41.7654L1.31055 41.6394L1.21777 25.8171H26.3496L26.4424 41.6169ZM26.3379 23.8171H1.20605L1.17773 18.9998H26.3096L26.3379 23.8171Z" fill="#E0B004"/>
  </svg>
);

/**
 * Progress bar showing completion percentage
 */
export const ProgressBar = ({ currentStep, totalSteps }) => (
  <div style={{ marginBottom: '20px' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
      <span style={{ fontFamily: 'Poppins, sans-serif', fontWeight: '500', fontSize: '13px', color: colors.darkTeal }}>
        Step {currentStep} of {totalSteps}
      </span>
      <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '13px', color: colors.mediumGray }}>
        {Math.round((currentStep / totalSteps) * 100)}% complete
      </span>
    </div>
    <div style={{ height: '5px', backgroundColor: colors.lighterGray, borderRadius: '3px', overflow: 'hidden' }}>
      <div
        style={{
          height: '100%',
          width: `${(currentStep / totalSteps) * 100}%`,
          backgroundColor: '#F0CC4C',
          borderRadius: '3px',
          transition: 'width 0.3s ease',
        }}
      />
    </div>
  </div>
);

/**
 * Step indicator with clickable completed steps
 */
export const StepIndicator = ({ steps, currentStep, onStepClick }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
      {steps.map((step, idx) => {
        const stepNum = idx + 1;
        const isCompleted = stepNum < currentStep;
        const isCurrent = stepNum === currentStep;
        const isClickable = isCompleted;

        return (
          <div key={step} style={{ display: 'flex', alignItems: 'center' }}>
            <button
              type="button"
              onClick={() => isClickable && onStepClick(stepNum)}
              disabled={!isClickable}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                background: 'none',
                border: 'none',
                padding: '4px',
                cursor: isClickable ? 'pointer' : 'default',
                opacity: 1,
              }}
              aria-label={isClickable ? `Go back to ${step}` : step}
            >
              <div
                style={{
                  width: '22px',
                  height: '22px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontFamily: 'Poppins, sans-serif',
                  fontWeight: '600',
                  fontSize: '11px',
                  backgroundColor: stepNum <= currentStep ? colors.darkTeal : colors.lighterGray,
                  color: stepNum <= currentStep ? colors.white : colors.mediumGray,
                  transition: 'transform 0.2s',
                }}
              >
                {isCompleted ? '✓' : stepNum}
              </div>
              <span
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '12px',
                  color: isCurrent ? colors.darkTeal : colors.mediumGray,
                  fontWeight: isCurrent ? '600' : '400',
                  textDecoration: isClickable ? 'underline' : 'none',
                }}
              >
                {step}
              </span>
            </button>
            {idx < steps.length - 1 && (
              <div
                style={{
                  width: '16px',
                  height: '1px',
                  backgroundColor: isCompleted ? colors.darkTeal : colors.lighterGray,
                  margin: '0 6px',
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

/**
 * Review item for displaying form data in review step
 */
export const ReviewItem = ({ label, value }) => (
  <div style={{ marginBottom: '8px' }}>
    <span
      style={{
        fontFamily: 'Inter, sans-serif',
        fontSize: '12px',
        color: colors.mediumGray,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
      }}
    >
      {label}
    </span>
    <div
      style={{
        fontFamily: 'Inter, sans-serif',
        fontSize: '15px',
        color: colors.nearBlack,
        fontWeight: '500',
      }}
    >
      {value || '—'}
    </div>
  </div>
);

/**
 * Form wrapper with header and styling
 */
export const FormWrapper = ({ title, subtitle, children }) => (
  <div style={{ minHeight: '100vh', backgroundColor: colors.offWhite, fontFamily: 'Inter, sans-serif' }}>
    <style>{mobileStyles}</style>
    <div style={{ backgroundColor: colors.white, padding: '16px 0', borderBottom: `1px solid ${colors.lighterGray}` }}>
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 24px', textAlign: 'center' }}>
        <Logo />
      </div>
    </div>
    <div style={{ backgroundColor: colors.darkTeal, padding: '16px 0' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 24px' }}>
        <h1
          style={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: '700',
            fontSize: '20px',
            color: colors.white,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            margin: 0,
          }}
        >
          {title}
        </h1>
        <p style={{ fontFamily: 'Inter, sans-serif', color: colors.lightTeal, margin: '4px 0 0 0', fontSize: '14px' }}>
          {subtitle}
        </p>
      </div>
    </div>
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '16px 24px 48px' }}>{children}</div>
  </div>
);

/**
 * Navigation buttons for form steps
 */
export const FormNavigation = ({
  currentStep,
  totalSteps,
  onPrevious,
  onNext,
  onSubmit,
  isSubmitting,
  submitStatus,
  buttonPrimary,
  buttonSecondary,
  buttonDisabled,
}) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '32px',
      paddingTop: '24px',
      borderTop: `1px solid ${colors.lighterGray}`,
    }}
  >
    {currentStep > 1 ? (
      <button onClick={onPrevious} type="button" style={buttonSecondary}>
        ← Previous
      </button>
    ) : (
      <div />
    )}
    {currentStep < totalSteps ? (
      <button onClick={onNext} type="button" style={buttonPrimary}>
        Continue →
      </button>
    ) : submitStatus === 'success' ? (
      <div style={{ fontFamily: 'Poppins, sans-serif', fontWeight: '600', color: colors.darkTeal }}>
        Submitted Successfully
      </div>
    ) : (
      <button onClick={onSubmit} type="button" disabled={isSubmitting} style={isSubmitting ? buttonDisabled : buttonPrimary}>
        {isSubmitting ? 'Submitting...' : 'Submit Quote Request'}
      </button>
    )}
  </div>
);

/**
 * Success page after form submission
 */
export const SuccessPage = ({ title, message, email, additionalInfo, showTimeline = true }) => (
  <div style={{ textAlign: 'center', padding: '40px 20px' }}>
    <div
      style={{
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        backgroundColor: '#c6f6d5',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 24px',
        fontSize: '40px',
      }}
    >
      ✓
    </div>
    <h2
      style={{
        fontFamily: 'Poppins, sans-serif',
        fontWeight: '700',
        fontSize: '28px',
        color: colors.darkTeal,
        margin: '0 0 16px 0',
      }}
    >
      {title}
    </h2>
    <p
      style={{
        fontFamily: 'Inter, sans-serif',
        fontSize: '16px',
        color: colors.mediumGray,
        margin: '0 0 24px 0',
        maxWidth: '500px',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      {message}
    </p>

    {/* Expected Timeline */}
    {showTimeline && (
      <div style={{ backgroundColor: colors.white, border: `1px solid ${colors.lighterGray}`, borderRadius: '8px', padding: '24px', maxWidth: '500px', margin: '0 auto 24px', textAlign: 'left' }}>
        <h3 style={{ fontFamily: 'Poppins, sans-serif', fontWeight: '600', fontSize: '16px', color: colors.darkTeal, margin: '0 0 16px 0' }}>
          What Happens Next?
        </h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
            <div style={{ width: '24px', height: '24px', borderRadius: '50%', backgroundColor: colors.lightestTeal, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontFamily: 'Poppins, sans-serif', fontWeight: '600', fontSize: '12px', color: colors.darkTeal }}>1</div>
            <div>
              <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', color: colors.darkGray, margin: 0 }}><strong>Within 24 hours:</strong> We review your submission and gather quotes from our carrier partners.</p>
            </div>
          </div>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
            <div style={{ width: '24px', height: '24px', borderRadius: '50%', backgroundColor: colors.lightestTeal, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontFamily: 'Poppins, sans-serif', fontWeight: '600', fontSize: '12px', color: colors.darkTeal }}>2</div>
            <div>
              <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', color: colors.darkGray, margin: 0 }}><strong>1-2 business days:</strong> We'll contact you with quote options and coverage recommendations.</p>
            </div>
          </div>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
            <div style={{ width: '24px', height: '24px', borderRadius: '50%', backgroundColor: colors.lightestTeal, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontFamily: 'Poppins, sans-serif', fontWeight: '600', fontSize: '12px', color: colors.darkTeal }}>3</div>
            <div>
              <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', color: colors.darkGray, margin: 0 }}><strong>Same day binding:</strong> Once you choose a quote, we can often bind coverage the same day.</p>
            </div>
          </div>
        </div>
      </div>
    )}

    <div style={{ backgroundColor: colors.lightestTeal, padding: '20px', borderRadius: '8px', maxWidth: '400px', margin: '0 auto' }}>
      <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', color: colors.darkGray, margin: '0 0 8px 0' }}>
        <strong>Have questions?</strong>
      </p>
      <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', color: colors.darkGray, margin: 0 }}>
        Email us at{' '}
        <a href={`mailto:${email}`} style={{ color: colors.darkTeal, fontWeight: '600' }}>
          {email}
        </a>
      </p>
    </div>
    {additionalInfo && (
      <div style={{ marginTop: '32px' }}>
        <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '13px', color: colors.lightGray }}>{additionalInfo}</p>
      </div>
    )}
  </div>
);
